import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { apiClient } from '@/shared/services/apiConfig';
import { AccountL2VPNCircuit, L2VPNCircuit } from '@/shared/types/l2vpnTypes';
import { PaginatedResponse } from '@/shared/types/responseTypes';

/** Infinite scroll fetch for l2vpn circuits load-more. */
export const useInfiniteL2VPNCircuits = (regionCode: string | undefined) => {
  return useInfiniteQuery({
    queryKey: ['region-l2vpn-circuits-infinite', regionCode],
    queryFn: async ({ pageParam }: { pageParam: number }) => {
      const response = await apiClient.get<PaginatedResponse<AccountL2VPNCircuit>>(
        `/enterprise/v1/l2vpn-circuits`,
        { params: { regionCode, page: pageParam } }
      );
      return response.data;
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage, _pages, lastPageParam) =>
      lastPage.isLastPage ? undefined : lastPageParam + 1,
    enabled: !!regionCode,
  });
};

// Use Starlink L2VPN Query
export const useStarlinkL2VPNCircuits = (enabled: boolean, regionCode: string | undefined) => {
  return useQuery({
    queryKey: ['region-starlink-l2vpn-circuits', regionCode],
    queryFn: async () => {
      const response = await apiClient.get<PaginatedResponse<L2VPNCircuit>>(
        '/enterprise/v1/l2vpn-circuits/starlink-l2vpn-circuits',
        { params: { regionCode } }
      );
      return response.data.results;
    },
    enabled: enabled && !!regionCode
  });
};